var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ModalConfig } from '../../../model/modal-config';
import { LabelkeyService } from '../../../services/labelkey/labelkey.service';
import { BaseActions } from '../../../shared/base-actions';
import { Order } from '../../../model/order';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
import { Router } from '@angular/router';
import { TvShopEntertainmentPackGroupIds } from '../../../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';
var OrderingModalManagerComponent = /** @class */ (function (_super) {
    __extends(OrderingModalManagerComponent, _super);
    function OrderingModalManagerComponent(navigationService, labelkeyService, router, stateService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.labelkeyService = labelkeyService;
        _this.router = router;
        _this.stateService = stateService;
        _this.modalConfig = new ModalConfig();
        _this.title = 'eos-tv-shop-ii.title.input-pincode-modal';
        _this.description = 'eos-tv-shop-ii.text.input-pincode-modal-pincode';
        return _this;
    }
    OrderingModalManagerComponent.prototype.ngOnInit = function () {
    };
    OrderingModalManagerComponent.prototype.ngOnChanges = function (changes) {
        this.setLabels();
    };
    OrderingModalManagerComponent.prototype.openModal = function () {
        this.modalConfig.showOrderPincode = true;
        this.setAdditionalModalConfig();
        this.navigationState = Object.assign({}, this.navigationService.state);
        this.registerComponent(PageNames.PINCODE_MODAL);
    };
    OrderingModalManagerComponent.prototype.openConditions = function () {
        this.modalConfig.showOrderPincode = false;
        this.modalConfig.showOrderConditions = true;
        this.setAdditionalModalConfig();
        this.conditionsLabelKey = this.labelkeyService.getConditionsModalLabelKey(this.order.packOmapiId);
        this.registerComponent(PageNames.CONDITIONS_MODAL);
    };
    OrderingModalManagerComponent.prototype.openOrderSucceeded = function () {
        this.modalConfig.showOrderPincode = false;
        this.modalConfig.showOrderSucceeded = true;
        this.setAdditionalModalConfig();
        this.registerComponent(PageNames.ORDERING_SUCCEEDED);
    };
    OrderingModalManagerComponent.prototype.openOrderFailed = function (orderFailed) {
        this.error = orderFailed.error;
        this.modalConfig.showOrderPincode = false;
        this.modalConfig.showOrderFailed = true;
        this.setAdditionalModalConfig();
        this.registerComponent(PageNames.ORDERING_FAILED);
    };
    OrderingModalManagerComponent.prototype.openOrderMessage = function () {
        this.modalConfig.showOrderPincode = false;
        this.modalConfig.showOrderMessage = true;
        this.setAdditionalModalConfig();
        this.registerComponent(PageNames.ORDERING_MESSAGE);
    };
    OrderingModalManagerComponent.prototype.closeModal = function () {
        if (this.shouldComeBackToProductDetailScreen()) {
            this.backToDetailPage();
        }
        this.modalConfig = new ModalConfig();
        this.registerComponent(PageNames.DETAIL_PAGE_INTRO);
        if (!this.modalConfig.showOrderConditions && !this.modalConfig.showOrderPincode) {
            this.navigationService.state = this.navigationState;
        }
        this.setAdditionalModalConfig();
        this.ngOnDestroy();
    };
    OrderingModalManagerComponent.prototype.closeConditions = function () {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showOrderPincode = true;
        this.setAdditionalModalConfig();
        this.registerComponent(PageNames.PINCODE_MODAL);
    };
    OrderingModalManagerComponent.prototype.registerComponent = function (pageName) {
        this.navigationService.clearNavigation();
        this.navigationService.setCurrentPageComponent(pageName);
    };
    OrderingModalManagerComponent.prototype.onBack = function () {
        this.closeModal();
    };
    OrderingModalManagerComponent.prototype.backToDetailPage = function () {
        this.navigationService.resetNavigation();
        this.navigationService.clearNavigation();
        this.routeOnBackPressed();
    };
    OrderingModalManagerComponent.prototype.routeOnBackPressed = function () {
        this.router.navigate(['/product-details/' + this.completeRedirectUrl()], { queryParamsHandling: 'merge' });
    };
    Object.defineProperty(OrderingModalManagerComponent.prototype, "orderSucceededTitleKey", {
        get: function () {
            var pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
            return this.labelkeyService.getOrderSucceededTitleKey(pack);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderingModalManagerComponent.prototype, "orderSucceededDescriptionKey", {
        get: function () {
            var pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
            return this.labelkeyService.getOrderSucceededDescriptionKey(pack);
        },
        enumerable: true,
        configurable: true
    });
    OrderingModalManagerComponent.prototype.setLabels = function () {
        var pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        if (this.order && this.order.type === Order.DAYPASS) {
            this.title = 'eos-tv-shop-ii.title.input-pincode-modal-day-pass';
            this.description = 'eos-tv-shop-ii.text.input-pincode-modal-day-pass';
        }
        if (pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct)) {
            this.title = 'eos-tv-shop-ii.title.input-pincode-modal-streaming-bundles';
            this.description = 'eos-tv-shop-ii.text.input-pincode-modal-streaming-bundles';
        }
    };
    OrderingModalManagerComponent.prototype.setAdditionalModalConfig = function () {
        var pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        this.modalConfig.showLogo = !(pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct));
        this.modalConfig.showHintInfoKey = !(pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct));
    };
    OrderingModalManagerComponent.prototype.shouldComeBackToProductDetailScreen = function () {
        return this.navigationState.currentPageActiveComponent === PageNames.STREAMING_BUNDLE_OPTION ||
            this.navigationState.currentPageActiveComponent === PageNames.STANDALONE_FLAVORS ||
            this.navigationState.currentPageActiveComponent === PageNames.PACK_OPTION_SELECTION;
    };
    OrderingModalManagerComponent.prototype.completeRedirectUrl = function () {
        var urlParameter;
        switch (this.navigationState.currentPageActiveComponent) {
            case PageNames.STREAMING_BUNDLE_OPTION:
            case PageNames.PACK_OPTION_SELECTION:
                urlParameter = this.order.packOmapiId;
                break;
            case PageNames.STANDALONE_FLAVORS:
                urlParameter = TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE;
                break;
        }
        return urlParameter;
    };
    return OrderingModalManagerComponent;
}(BaseActions));
export { OrderingModalManagerComponent };
